














import Vue, { PropType } from 'vue';
import { Inverter } from '@/types';

export default Vue.extend({
  props: {
    value: Number,
    item: {
      type: Object as PropType<Inverter>,
    },
  },

  data() {
    return {
      input: 0,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val: number) {
        this.input = val;
      },
    },
  },

  methods: {
    save() {
      this.$emit('input', this.input);
      this.$emit('save', this.input);
    },
  },
});
